module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_header_m-4bbb25eef1cb693d4b3039031c891718.jpg";